export type Kind = 'X-Ray' | 'MRI' | 'Lab' | 'Ultrasound' | 'PatientInstruction' | 'PointOfCare';

export enum OrderKind {
  XRay = 'X-Ray',
  Mri = 'MRI',
  Lab = 'Lab',
  Ultrasound = 'Ultrasound',
  PatientInstruction = 'PatientInstruction',
  PointOfCare = 'PointOfCare',
}

export enum Status {
  Proposed = 'proposed',
  ApprovedOnDevice = 'approvedOnDevice',
  SubmittingToEhr = 'submittingToEhr',
  SubmittedToEhr = 'submittedToEhr',
  NeedsManualSubmit = 'needsManualSubmit',
  ApprovedInEhr = 'approvedInEhr',
}

export enum OrderParameterKind {
  INPUT = 'INPUT',
  SELECT = 'SELECT',
  UNSELECT = 'UNSELECT',
  CHECK = 'CHECK',
  UNCHECK = 'UNCHECK',
}

export interface OrderParameter {
  name: string;
  kind: OrderParameterKind;
  value: string;
}

export interface Order {
  id: string;
  kind: Kind;
  encounterId: string;
  status: Status;
  icd10s: string[];
  encounterProblemId: string;
  parameters?: OrderParameter[];
  [key: string]: string | Status | string[] | OrderParameter[] | undefined;
}

export interface StructuredOrder extends Order {
  side?: string;
  view?: string;
  bodyPart?: string;
  workflowId: string;
  name?: string;
}

export enum GetOrderOption {
  GetOneById = 'GetOneById',
  FindAll = 'FindAll',
}
